export default "__VITE_ASSET__OIWgoh9n__"